import faqLinks from 'appConfig/faqLinks';

import { getLanguage } from 'api/utils/languageManagment';

import { DEFAULT_LANGUAGE } from 'constants/localization';

import isMobile from './isMobile';

type KeyType = keyof typeof faqLinks.ios;

function isListedLanguage(language: string): language is KeyType {
  return language in faqLinks.ios;
}

export const getFaqLink = () => {
  const language = getLanguage();

  if (isMobile.iOS()) {
    return isListedLanguage(language) ? faqLinks.ios[language] : faqLinks.ios[DEFAULT_LANGUAGE];
  }

  if (isMobile.android()) {
    return isListedLanguage(language) ? faqLinks.android[language] : faqLinks.android[DEFAULT_LANGUAGE];
  }

  return isListedLanguage(language) ? faqLinks.desktop[language] : faqLinks.desktop[DEFAULT_LANGUAGE];
};
